import React from 'react';
import TextNodeForm from 'routes/surface/components/node-modal-form/components/text-node-modal/components/text-node-form';
import useSurfaceNodeInitialValuesFromServer from 'routes/surface/components/node-modal-form/hooks/use-surface-node-initial-values-from-server';
import useSaveSurfaceTextNode from 'routes/surface/components/node-modal-form/hooks/use-save-surface-text-node';
import { withModal } from 'hoc';
import { set, flow, omit } from 'lodash/fp';
import { ModalContext } from 'hoc/with-modal';
import { NodeModalInput } from 'types';
import { SurfaceTextNode } from 'graphql/types';

export interface TextNodeModalContentProps {
  data: NodeModalInput<SurfaceTextNode>;
  modal: ModalContext;
}

function TextNodeModalContent(props: TextNodeModalContentProps) {
  const {
    initialValues: data,
    isLoading,
  } = useSurfaceNodeInitialValuesFromServer<SurfaceTextNode>(props.data);

  const saveSurfaceTextNode = useSaveSurfaceTextNode();

  function onSubmit(input) {
    return saveSurfaceTextNode({ variables: { input } });
  }

  const initialValues = flow(
    set('slateData', { data: data.slateData, text: data.text }),
    omit(['text']),
  )(data);

  if (isLoading) {
    return null;
  }

  return (
    <TextNodeForm
      onSubmit={onSubmit}
      initialValues={initialValues}
      closeForm={props.modal.hide}
    />
  );
}

export default withModal(TextNodeModalContent);
